import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-filter-item-select',
  templateUrl: './filter-item-select.component.html',
  styleUrls: ['./filter-item-select.component.scss']
})
export class FilterItemSelectComponent {

  @Input() title = {text:"", icon:"", iconClass:""};
  @Input() optionItems: any[] = [];
  @Input() multiple: boolean = true;
  @Output() selectionChange = new EventEmitter<any[]>();

  selectedItems: any[] = [];
  search = "";

  getOptions(){
    return this.optionItems.filter(i=>i.viewValue.toLowerCase().includes(this.search.toLowerCase()))
  }

  onSelectionChange() {
    this.selectionChange.emit(this.selectedItems);
  }
}
